/** Invite a shop: the owner's link, the rules, and the shops it brought in. */
const referrals = {
  en: {
    title: "Invite a shop",
    subtitle: "Know another shop owner? Invite them: when both of your shops have paid a month, each gets one month free.",
    yourLink: "Your invitation link",
    copy: "Copy the link",
    copied: "Copied",
    share: "Send on WhatsApp",
    shareText: "I use this app to run my shop: the till, stock and a QR menu for customers. Start your free trial with my link: {link}",
    rulesTitle: "The rules",
    rules: [
      "Send your link to another shop. A shop that creates its account through your link is linked to you — only at sign-up; it cannot be added afterwards.",
      "The new shop gets its free trial, as every new shop does.",
      "When both shops have paid at least one month, the invitation counts.",
      "We check it (usually within a few days) and add one free month to each shop's subscription. We tell you both by email.",
      "There is no limit: every shop you bring in earns you another month.",
      "If your subscription is overdue or suspended at that moment, your free month is kept and added at your next payment.",
      "Not counted: a shop you own yourself, a shop already on the platform, or a link added after sign-up.",
    ],
    invitedTitle: "Shops you invited",
    none: "Nobody has signed up with your link yet.",
    banked: { one: "{count} free month waits for your next payment.", other: "{count} free months wait for your next payment." },
    status: {
      signed_up: "Signed up",
      qualified: "Both paid — being checked",
      approved: "Free month given",
      rejected: "Not counted",
    },
    waitingThem: "waiting for their first payment",
    waitingYou: "waiting for your first payment",
    loadFailed: "Could not load your invitations.",
  },

  fr: {
    title: "Inviter une boutique",
    subtitle: "Vous connaissez un autre gérant de boutique ? Invitez-le : quand vos deux boutiques ont payé un mois, chacune reçoit un mois offert.",
    yourLink: "Votre lien d'invitation",
    copy: "Copier le lien",
    copied: "Copié",
    share: "Envoyer sur WhatsApp",
    shareText: "J'utilise cette application pour gérer ma boutique : la caisse, le stock et un menu QR pour les clients. Commencez votre essai gratuit avec mon lien : {link}",
    rulesTitle: "Les règles",
    rules: [
      "Envoyez votre lien à une autre boutique. Une boutique qui crée son compte avec votre lien vous est rattachée — uniquement à l'inscription ; cela ne peut pas être ajouté après.",
      "La nouvelle boutique a son essai gratuit, comme toute nouvelle boutique.",
      "Quand les deux boutiques ont payé au moins un mois, l'invitation compte.",
      "Nous la vérifions (en général sous quelques jours) et ajoutons un mois offert à l'abonnement de chaque boutique. Nous vous prévenons tous les deux par e-mail.",
      "Il n'y a pas de limite : chaque boutique que vous amenez vous rapporte un mois de plus.",
      "Si votre abonnement est en retard ou suspendu à ce moment-là, votre mois offert est gardé et ajouté à votre prochain paiement.",
      "Ne comptent pas : une boutique qui vous appartient, une boutique déjà inscrite, ou un lien ajouté après l'inscription.",
    ],
    invitedTitle: "Boutiques invitées",
    none: "Personne ne s'est encore inscrit avec votre lien.",
    banked: { one: "{count} mois offert attend votre prochain paiement.", other: "{count} mois offerts attendent votre prochain paiement." },
    status: {
      signed_up: "Inscrite",
      qualified: "Les deux ont payé — vérification",
      approved: "Mois offert",
      rejected: "Non retenue",
    },
    waitingThem: "en attente de son premier paiement",
    waitingYou: "en attente de votre premier paiement",
    loadFailed: "Impossible de charger vos invitations.",
  },

  ar: {
    title: "دعوة متجر",
    subtitle: "تعرف صاحب متجر آخر؟ ادعه: عندما يدفع متجراكما شهرًا، يحصل كلٌّ منهما على شهر مجاني.",
    yourLink: "رابط دعوتك",
    copy: "نسخ الرابط",
    copied: "نُسخ",
    share: "إرسال عبر واتساب",
    shareText: "أستخدم هذا التطبيق لإدارة متجري: الصندوق والمخزون وقائمة QR للزبائن. ابدأ تجربتك المجانية برابطي: {link}",
    rulesTitle: "القواعد",
    rules: [
      "أرسل رابطك إلى متجر آخر. المتجر الذي ينشئ حسابه عبر رابطك يُربط بك — عند التسجيل فقط؛ ولا يمكن إضافته لاحقًا.",
      "يحصل المتجر الجديد على تجربته المجانية، كأي متجر جديد.",
      "عندما يدفع المتجران شهرًا واحدًا على الأقل، تُحتسب الدعوة.",
      "نتحقّق منها (عادةً خلال أيام قليلة) ونضيف شهرًا مجانيًا إلى اشتراك كل متجر، ونُعلمكما بالبريد الإلكتروني.",
      "لا يوجد حدّ: كل متجر تجلبه يمنحك شهرًا إضافيًا.",
      "إذا كان اشتراكك متأخرًا أو موقوفًا حينها، نحتفظ بشهرك المجاني ونضيفه عند دفعتك القادمة.",
      "لا يُحتسب: متجر تملكه أنت، أو متجر مسجّل من قبل، أو رابط أُضيف بعد التسجيل.",
    ],
    invitedTitle: "المتاجر التي دعوتها",
    none: "لم يسجّل أحد برابطك بعد.",
    banked: {
      zero: "لا توجد أشهر مجانية بالانتظار.",
      one: "شهر مجاني ينتظر دفعتك القادمة.",
      two: "شهران مجانيان ينتظران دفعتك القادمة.",
      few: "{count} أشهر مجانية تنتظر دفعتك القادمة.",
      many: "{count} شهرًا مجانيًا ينتظر دفعتك القادمة.",
      other: "{count} شهر مجاني ينتظر دفعتك القادمة.",
    },
    status: {
      signed_up: "سجّل",
      qualified: "دفع الاثنان — قيد التحقق",
      approved: "مُنح الشهر المجاني",
      rejected: "غير محتسبة",
    },
    waitingThem: "بانتظار دفعته الأولى",
    waitingYou: "بانتظار دفعتك الأولى",
    loadFailed: "تعذّر تحميل دعواتك.",
  },
};

export default referrals;
